import img1 from  '../SalesTimer/images/img2.png';
import img2 from  '../SalesTimer/images/img1.png';
import img3 from  '../SalesTimer/images/img3.png';
import img4 from  '../SalesTimer/images/img4.png';
export const FlashSaleData=[{
    id:1,
    discount:-40,
    img:img1,
    title:"HAVIT HV-G92 Gamepad",
    categoryItem:"gaming",
    actualPrice:160,
    currentPrice:120,
    reviews:88,
    starRate:5

},{
    id:2,
    discount:-35,
    img:img2,
    title:"AK-900 Wired Keyboard",
    categoryItem:"electronic",
    actualPrice:1160,
    currentPrice:960,
    reviews:75,
    starRate:4

},{
    id:3,
    discount:-30,
    img:img3,
    title:"IPS LCD Gaming Monitor",
    categoryItem:"electronic",
    actualPrice:400,
    currentPrice:370,
    reviews:99,
    starRate:5

},{
    id:4,
    discount:-25,
    img:img4,
    title:"S-Series Comfort Chair ",
    categoryItem:"electronic",
    actualPrice:400,
    currentPrice:375,
    reviews:98,
    starRate:4.5

},{
    id:5,
    discount:-25,
    img:img4,
    title:"S-Series Comfort Chair ",
    actualPrice:400,
    currentPrice:375,
    reviews:98,
    starRate:4.5

},{
    id:6,
    discount:-25,
    img:img4,
    title:"S-Series Comfort Chair ",
    actualPrice:400,
    currentPrice:375,
    reviews:98,
    starRate:4.5

}]